import { css, sva } from "@stubhub/broadway-foundation/css";

export type PerformerGridVariant = "default" | "compact";

export const performerGridEntryRecipe = sva({
  slots: ["container", "image", "title", "eventCount", "favButton"],
  className: "performerGridEntry",
  base: {
    container: {
      display: "flex",
      alignItems: "center",
      borderStartStartRadius: "element.default",
      borderStartEndRadius: "element.default",
      borderEndEndRadius: "element.default",
      borderEndStartRadius: "element.default",
      paddingBlock: "primitives.50",
      paddingInline: "primitives.50",
      transitionProperty: "[all]",
      transitionDuration: "change.quick",
      position: "relative",
      cursor: "pointer",
      _hover: {
        backgroundColor: "bg.surface.hover",
      },
    },
    image: {
      gridRowStart: "image",
      gridColumnStart: "image",
      borderStartStartRadius: "element.default",
      borderStartEndRadius: "element.default",
      borderEndEndRadius: "element.default",
      borderEndStartRadius: "element.default",
      objectFit: "cover",
    },
    title: {
      color: "text",
      marginInlineStart: "primitives.250",
      textStyle: "title.medium",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    eventCount: {
      textStyle: "body.small",
      color: "text.subtle",
    },
    favButton: {
      position: "absolute",
      insetInlineEnd: "primitives.200",
    },
  },
  variants: {
    variant: {
      default: {
        title: {
          maxWidth: "[60%]",
        },
        eventCount: {
          display: "none",
        },
      },
      compact: {
        container: {
          paddingBlock: "[10px]",
          paddingInline: "[10px]",
          columnGap: "primitives.200",
          textDecorationLine: "none",
          borderBlockWidth: "thin",
          borderInlineWidth: "thin",
          borderBlockStyle: "solid",
          borderInlineStyle: "solid",
          borderBlockColor: "border",
          borderInlineColor: "border",
          _hover: {
            backgroundColor: "bg.surface.hover",
            textDecorationLine: "none",
          },
        },
        title: {
          display: "flex",
          flexDirection: "column",
          flexGrow: "1",
          marginInlineStart: "primitives.0",
        },
        eventCount: {
          display: "block",
        },
        favButton: {
          display: "none",
        },
      },
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export const performerGridRecipe = sva({
  slots: ["container", "title", "grid"],
  className: "performerGrid",
  base: {
    container: {},
    title: {},
    grid: {
      marginBlockStart: "primitives.200",
      marginBlockEnd: "primitives.400",
    },
  },
  variants: {
    variant: {
      default: {},
      compact: {
        container: {},
        title: {
          textAlign: "start",
          alignItems: "flex-start",
        },
        grid: {
          display: "grid",
          rowGap: "primitives.150",
          tablet: {
            display: "grid",
            rowGap: "primitives.300",
            columnGap: "primitives.300",
            alignSelf: "stretch",
            gridTemplateRows: "[repeat(2,fit-content(100%))]",
            gridTemplateColumns: "[repeat(2,minmax(0,1fr))]",
            gridAutoFlow: "row",
          },
        },
      },
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export const gridWrapper = css({
  marginBlockStart: "primitives.200",
  marginBlockEnd: "primitives.400",
});
